export function LogoMark({ className = '' }: { className?: string }) {
  return (
    <span className={`tr-logo-mark ${className}`} aria-hidden="true">
      <svg aria-hidden="true" fill="none" viewBox="0 0 100 100">
        <circle cx="50" cy="50" r="46" stroke="var(--tr-secondary)" strokeWidth="3" />
        <circle cx="50" cy="50" r="36" stroke="var(--tr-secondary)" strokeWidth="2" />
        <circle cx="50" cy="50" r="26" stroke="var(--tr-secondary)" strokeWidth="2" />
        <circle
          cx="50"
          cy="50"
          fill="var(--tr-accent)"
          r="14"
          stroke="var(--tr-secondary)"
          strokeWidth="2"
        />
        <circle cx="50" cy="50" fill="var(--tr-secondary)" r="5" />
      </svg>
    </span>
  );
}

export function BrandWordmark({
  accentClassName = 'text-primary',
  className = '',
}: {
  accentClassName?: string;
  className?: string;
}) {
  return (
    <span className={className}>
      Trini<span className={accentClassName}>Rewards</span>
    </span>
  );
}

export function Logo({
  accentClassName = 'text-primary',
  className = '',
  href = '/',
  markClassName = '',
  wordmarkClassName = '',
}: {
  accentClassName?: string;
  className?: string;
  href?: string;
  markClassName?: string;
  wordmarkClassName?: string;
}) {
  return (
    <a className={`tr-logo ${className}`.trim()} href={href}>
      <LogoMark className={markClassName} />
      <BrandWordmark
        accentClassName={accentClassName}
        className={`tr-logo-wordmark ${wordmarkClassName}`.trim()}
      />
    </a>
  );
}
